/**
 * Polyfill for legacy libraries that expect 'global', 'process', or 'Buffer' to be present.
 * This is a production-ready way to handle environment differences when using Vite.
 */

if (typeof window !== 'undefined') {
  // Polyfill 'global' for libraries like react-image-lightbox
  window.global = window;
  
  // Polyfill 'process'
  if (typeof window.process === 'undefined') {
    window.process = {
      env: { NODE_ENV: import.meta.env.MODE || 'development' },
      nextTick: (fn, ...args) => setTimeout(() => fn(...args), 0),
      browser: true,
    };
  } else {
    window.process.env = window.process.env || {};
    window.process.env.NODE_ENV = window.process.env.NODE_ENV || import.meta.env.MODE || 'development';
  }

  // Polyfill 'Buffer'
  if (typeof window.Buffer === 'undefined') {
    window.Buffer = {
      isBuffer: () => false,
    };
  }
}
